'use client';
import '@/styles/globals.css';

import React from 'react';
import {twMerge} from 'tailwind-merge';

import Card from '@/components/base/Card';
import Icon from '@/components/base/Icon';
import Typography from '@/components/base/Typography';
import {LoaderVariants} from '@/enums/Icon';
import useRouter from '@/utils/hooks/useRouter';

function NotFound({className}: {className?: string}) {
  const router = useRouter();
  return (
    <div className={twMerge('flex size-full flex-col items-center', className)}>
      <div className="relative flex h-[132px] w-full justify-center bg-[#678898] pt-8">
        <Icon name="logo-horizontal-small" width={177} height={31} className="text-white" loaderVariant={LoaderVariants.NONE} />
      </div>
      <Card className="absolute top-[95px] flex h-[308px] w-[621px] flex-col items-center gap-4 border border-base-200 bg-base-100 px-8 py-[42px] ">
        <div className="flex items-center gap-4">
          <div className="flex size-[56px] items-center justify-center rounded-full">
            <Icon name="auth-failed" width={56} height={56} />
          </div>
        </div>
        <div className="text-center text-4xl font-bold text-base-700">Oh no!</div>

        <div className="flex flex-col items-center justify-center text-center text-lg text-base-700">
          This page could not be found.
          <br /> Please double check the link and try again.
        </div>
        <Typography variant={'h1'} className=" text-center text-base text-base-900">
          <span onClick={() => router.back()} className="cursor-pointer text-secondary underline">
            Return to Previous Page
          </span>
        </Typography>
      </Card>
    </div>
  );
}

export default NotFound;
